import { useParams, useSearchParams } from "react-router-dom";
import { LazyTyreFlow } from "./LazyTyreFlow";
import { isTyreDemo } from "../tyres/demo";

export function TyreRoute() {
  const { garageId = "" } = useParams();
  const [params] = useSearchParams();
  const demo = isTyreDemo(garageId, params.get("demo"));
  return (
    <main>
      <LazyTyreFlow
        key={`${garageId}-${demo}`}
        garageId={garageId}
        demo={demo}
      />
    </main>
  );
}
